<template>
  <div>
    <div class="google-map">
      <iframe
        :src="googleMapEmbedUrl"
        width="100%"
        height="auto"
        frameborder="0"
        class="border-0"
        :style="mapStyle ?? undefined"
        allowfullscreen
      ></iframe>
    </div>
    <button class="btn-order mt-2" @click="onClickConfirmRoute">
      <img src="@/assets/svg/GoogleMapIcon.svg" class="mr-1" />
      Google Mapでルート確認
    </button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { APP_GOOGLE_MAP_API_KEY } from "@/const/app";

@Component
export default class ConfirmRoute extends Vue {
  @Prop({
    type: String,
    required: false,
    default: null
  })
  latitude!: string | null;

  @Prop({
    type: String,
    required: false,
    default: null
  })
  longitude!: string | null;

  @Prop({
    type: String,
    required: false,
    default: null
  })
  mapStyle!: string | null;

  get apiKey() {
    return APP_GOOGLE_MAP_API_KEY;
  }

  get googleMapEmbedUrl() {
    return `https://www.google.com/maps/embed/v1/place?q=${this.latitude},${this.longitude}&zoom=16&key=${this.apiKey}`;
  }

  onClickConfirmRoute() {
    this.$emit("confirm-route");
  }
}
</script>

<style lang="scss" scoped>
.google-map {
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
